import $ from "jquery";
import Flickity from "flickity";
// import FlickityFade from "flickity-fade";
import "../vendors/flickity-imagesloaded/flickity-imagesloaded.js";

class VideoSlider {
	constructor($el) {
		this.$el = $el;

		this.options = {
			// autoPlay: true,
			imagesLoaded: true,
			pageDots: false,
			wrapAround: true,
			fade: true,
			prevNextButtons: true,
			freeScroll: true,
			cellSelector: ".section-slider__video__cell",
			arrowShape: { 
				x0: 10,
				x1: 80, y1: 50,
				x2: 15, y2: 1,
				x3: 85
			},
		};

		if (this.$el.length) {
			this._init();
		}
	}

    _init() {
        this.$slides = this.$el.find('.section-slider__video__cell');
        this.slidesCount = this.$slides.length;

        if(this.slidesCount > 1) {
            this._createSlider();
        }
    }

	_createSlider() {
        new Flickity(this.$el[0], this.options);
    }
}

export default VideoSlider;

